import { OrganizationRole } from '@/enums/roles';
import Dashboard from '@/views/Dashboard.vue';
import ActionPoints from '@/views/modules/ActionPoints.vue';
import type { RouteRecordRaw } from 'vue-router';

export enum ActionListType {
    Organization = 'org',
    ActionPoint = 'actie'
}

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/dashboard/:organizationId?',
        component: Dashboard,
        name: 'dashboard',
        meta: {
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: `/actielijst/:type(${ActionListType.Organization}|${ActionListType.ActionPoint})?/:id?`,
        name: 'actionPoints',
        component: ActionPoints,
        meta: {
            pageTitle: 'Actielijst',
            roles: [OrganizationRole.Employee]
        }
    }
];

export default routes;
